import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const DELETE_CASE_PARTICIPANT = "DELETE_CASE_PARTICIPANT";

export const service = async (eaCaseParticipantId) => {
  const options: object = {
    url: "/api/EaCaseApiController/DeleteCaseParticipant/" + eaCaseParticipantId,
    method: "POST",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(DELETE_CASE_PARTICIPANT, service, mock);
